import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import LiCoin from '@/views/LiCoin.vue'
import BuyLiCoin from '@/views/BuyLiCoin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue')
  },
  {
    path: '/checkout/cart',
    name: 'Cart',
    component: () => import('@/views/checkout/Cart.vue')
  },
  {
    path: '/checkout/order',
    name: 'Order',
    component: () => import('@/views/checkout/Order.vue')
  },
  {
    path: '/checkout/tappay-payment',
    name: 'TappayPayment',
    component: () => import('@/views/checkout/TappayPayment.vue')
  },
  {
    path: '/checkout/done',
    name: 'Done',
    component: () => import('@/views/checkout/Done.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('@/views/Member.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/licoin',
    name: 'LiCoin',
    component: LiCoin,
    meta: { requiresAuth: true }
  },
  {
    path: '/buy-licoin',
    name: 'BuyLiCoin',
    component: BuyLiCoin,
    meta: { requiresAuth: true }
  },
  // 商家後台路由
  {
    path: '/store/login',
    name: 'StoreLogin',
    component: () => import('@/views/store/StoreLogin.vue')
  },
  {
    path: '/store',
    name: 'StoreDashboard',
    component: () => import('@/views/store/Dashboard.vue'),
    meta: { 
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/products',
    name: 'StoreProducts',
    component: () => import('@/views/store/Products.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/categories',
    name: 'StoreCategories',
    component: () => import('@/views/store/Categories.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/orders',
    name: 'StoreOrders',
    component: () => import('@/views/store/Orders.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/navigation',
    name: 'StoreNavigation',
    component: () => import('@/views/store/Navigation.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/customers',
    name: 'StoreCustomers',
    component: () => import('@/views/store/Customers.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/labels',
    name: 'StoreLabels',
    component: () => import('@/views/store/Labels.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/settings',
    name: 'StoreSettings',
    component: () => import('@/views/store/Settings.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  },
  {
    path: '/store/news',
    name: 'StoreNews',
    component: () => import('@/views/store/News.vue'),
    meta: { 
      requiresAuth: true,
      layout: 'StoreLayout'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated
  const isUserAuthenticated = store.getters.isUserAuthenticated
  const user = store.getters.currentUser

  console.log('Router Guard Debug:', {
    to: to.path,
    isAuthenticated,
    isUserAuthenticated,
    user,
    userToken: localStorage.getItem('user_token'),
    userData: localStorage.getItem('user'),
    customerToken: localStorage.getItem('token'),
    customerData: localStorage.getItem('customer'),
    state: store.state
  })

  // 檢查是否為商家後台相關路由（不區分大小寫）
  const isStoreRoute = to.path.toLowerCase().startsWith('/store')

  // 特殊處理 /store 路由（不區分大小寫）
  if (to.path.toLowerCase() === '/store') {
    console.log('Checking /store access:', {
      isUserAuthenticated,
      userRole: user?.role,
      shouldAllow: isUserAuthenticated && user && (user.role === 'merchant' || user.role === 'admin')
    })
    
    if (isUserAuthenticated && user && (user.role === 'merchant' || user.role === 'admin')) {
      // 如果已經是商家用戶或管理員，允許訪問商家後台
      console.log('Allowing access to /store')
      next()
    } else {
      // 如果沒有商家權限，跳轉到商家登入頁面
      console.log('Redirecting to /store/login')
      next('/store/login')
    }
    return
  }

  // 特殊處理 /store/login 路由（不區分大小寫）
  if (to.path.toLowerCase() === '/store/login') {
    if (isUserAuthenticated && user && (user.role === 'merchant' || user.role === 'admin')) {
      // 如果已經是商家用戶或管理員，直接跳轉到商家後台
      next('/store')
    } else {
      // 允許訪問登入頁面
      next()
    }
    return
  }

  // 處理其他商家後台路由
  if (isStoreRoute && to.path.toLowerCase() !== '/store' && to.path.toLowerCase() !== '/store/login') {
    if (!isUserAuthenticated || !user || (user.role !== 'merchant' && user.role !== 'admin')) {
      // 如果沒有商家權限，跳轉到商家登入頁面
      next('/store/login')
    } else {
      // 有商家權限，允許訪問
      next()
    }
    return
  }

  // 處理一般路由的認證檢查
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要認證的路由（如 /member, /licoin 等）
    console.log('Checking auth for route:', to.path, {
      isAuthenticated,
      isUserAuthenticated,
      requiresAuth: to.meta.requiresAuth
    })
    
    // 對於客戶端專用路由，需要客戶端認證
    // 排除不需要登录的结账页面（cart, order, tappay-payment, done）
    const guestCheckoutPages = ['/checkout/cart', '/checkout/order', '/checkout/tappay-payment', '/checkout/done']
    const isGuestCheckoutPage = guestCheckoutPages.includes(to.path)
    
    if (to.path === '/member' || to.path === '/licoin' || to.path === '/buy-licoin' || 
        (to.path.startsWith('/checkout/') && !isGuestCheckoutPage)) {
      if (!isAuthenticated) {
        console.log('Customer not authenticated for client route, redirecting to login')
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        console.log('Customer authenticated, allowing access')
        next()
      }
    } else {
      // 其他需要認證的路由，檢查任一認證狀態
      if (!isAuthenticated && !isUserAuthenticated) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // 只允許訪客訪問的路由（如 /login, /register）
    if (isAuthenticated) {
      // 如果客戶已登入，跳轉到首頁
      next('/')
    } else if (isUserAuthenticated && user && (user.role === 'merchant' || user.role === 'admin')) {
      // 如果商家用戶已登入，跳轉到商家後台
      next('/store')
    } else {
      // 未登入，允許訪問
      next()
    }
  } else {
    // 一般路由，不需要特殊處理
    next()
  }
})

export default router 